// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3bd5K","filesListContainer":"PosDisputesFiles_filesListContainer__1BXGT","filesButton":"PosDisputesFiles_filesButton__2uSwT"};